var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
    _vm.hubbdata.openDyslexic ? 'open-dyslexic' : '',
    _vm.$route.path === '/welcome' || _vm.$route.path == '/terms' ? 'border' : '',
    _vm.isAndroid ? 'android-top-safe-area android-bottom-safe-area' : '' ]},[(_vm.$route.path != '/welcome')?_c('BypassBlock'):_vm._e(),(
      _vm.$route.path != '/welcome' &&
      _vm.$route.name != 'user_register' &&
      _vm.$route.path != '/terms'
    )?_c('Header'):_vm._e(),_c('v-main',{attrs:{"id":"main-content","tabindex":"-1"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }